// extracted by mini-css-extract-plugin
export default {"main":"About_main__7zBDe","bodyMain":"About_bodyMain__Mjp0u"};